import * as React from "react";
import { Loader2 } from "lucide-react";
import { cn } from "./utils";

interface FullPageLoaderProps {
  message?: string;
  className?: string;
}

export function FullPageLoader({
  message = "Loading...",
  className,
}: FullPageLoaderProps) {
  return (
    <div
      className={cn(
        "fixed inset-0 z-50 flex items-center justify-center bg-black/40 backdrop-blur-sm",
        className,
      )}
    >
      <div className="flex flex-col items-center space-y-3 rounded-lg bg-background px-6 py-5 shadow-xl">
        <Loader2 className="h-6 w-6 animate-spin text-electric-steel" />
        <p className="text-sm font-medium text-charcoal-ink">{message}</p>
      </div>
    </div>
  );
}



